function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { without } from 'lodash';
import { SET_EVENT_SAVED_STATE, UPDATE_COLLECTION_EVENTS, SET_EVENTS } from './actionTypes';
export default (function (state, _ref) {
  if (state === void 0) {
    state = {};
  }

  var type = _ref.type,
      payload = _ref.payload;
  var nextState = state;

  if (type === SET_EVENTS) {
    nextState = _objectSpread({}, nextState, payload.events);
  } else if (type === SET_EVENT_SAVED_STATE) {
    var _objectSpread2;

    nextState = _objectSpread({}, nextState, (_objectSpread2 = {}, _objectSpread2[payload.eventId] = _objectSpread({}, nextState[payload.eventId], {
      saves: {
        savedByYou: payload.saveState
      }
    }), _objectSpread2));
  } else if (type === UPDATE_COLLECTION_EVENTS) {
    var _objectSpread3;

    nextState = _objectSpread({}, nextState, (_objectSpread3 = {}, _objectSpread3[payload.eventId] = _objectSpread({}, nextState[payload.eventId], {
      eventCollections: payload.shouldAdd ? [].concat(nextState[payload.eventId].eventCollections, [payload.collectionId]) : without(nextState[payload.eventId].eventCollections, payload.collectionId)
    }), _objectSpread3));
  }

  return nextState;
});